import { BrowserModule } from '@angular/platform-browser';
import {Injector, NgModule} from '@angular/core';

import { AppComponent } from './components/app.component';
import { BausteinComponent } from './components/baustein/baustein.component';
import { BausteinHeaderComponent } from './components/baustein-header/baustein-header.component';
import { BausteinContentComponent } from './components/baustein-content/baustein-content.component';
import { RadioComponent } from './components/baustein-content/form-components/radio/radio.component';
import { DropdownComponent } from './components/baustein-content/form-components/dropdown/dropdown.component';
import { InfoToggleComponent } from './components/info-toggle/info-toggle.component';

import {createCustomElement} from '@angular/elements';
import { TooltipEnabledMarkupComponent } from './components/tooltip-enabled-markup/tooltip-enabled-markup.component';
import { HttpClientModule } from '@angular/common/http';
import { ErrorBoxComponent } from './components/error-box/error-box.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxLoadingModule } from 'node_modules/ngx-loading';


@NgModule({
  declarations: [
    AppComponent,
    BausteinComponent,
    BausteinHeaderComponent,
    BausteinContentComponent,
    RadioComponent,
    DropdownComponent,
    InfoToggleComponent,
    TooltipEnabledMarkupComponent,
    ErrorBoxComponent
  ],
  imports: [
    BrowserModule,
    NgxLoadingModule.forRoot({}),
    HttpClientModule,
    BrowserAnimationsModule
  ],
  entryComponents: [],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {}
  ngDoBootstrap() {
    const AppElement = createCustomElement(AppComponent, { injector: this.injector });
    customElements.define('app-root', AppElement);
  }
}
